import { useBooleanState } from '@cian/react-utils';
import * as React from 'react';

import { MobileSearchBlock } from 'shared/components/MobileSearchBlock';
import { SearchBlockModalContainer } from '../SearchBlockModalContainer';
import { DesktopSearchBlockLayout } from 'shared/components/DesktopSearchBlockLayout/DesktopSearchBlock';
import { DesktopSearchInputContainer } from '../DesktopSearchInputContainer';
import { SearchTipsContainer } from '../SearchTipsContainer/SearchTipsContainer';
import { IFullTipSchema } from 'shared/repositories/text-search/entities/tips/FullTipSchema';
import { SEARCH_TIPS } from 'shared/constants/constants';
import { Responsive } from '@cian/ui-kit';
import { Experiment } from '@cian/experiments/ab';
import { BX_DESCKTOP_MAIN_PAGE } from 'shared/constants/experiments';
import { useApplicationContext } from '../ApplicationContext';
import { fetchMainTips } from 'shared/services/fetchMainTips';
import { useSelector } from 'react-redux';
import { selectQueryString } from 'shared/selectors/queryString';

export const SearchBlockContainer: React.FC = () => {
  const context = useApplicationContext();
  const { state: isModalOpen, setTrue: setModalOpen, setFalse: setModalClose } = useBooleanState(false);

  const query = useSelector(selectQueryString);

  const [clickedTip, setClickedTip] = React.useState<IFullTipSchema | null>(null);
  const [tips, setTips] = React.useState<IFullTipSchema[]>(SEARCH_TIPS);

  React.useEffect(() => {
    const fetchTips = async () => {
      const response = await fetchMainTips(context, query);
      setTips(response?.tips || []);
    };
    fetchTips();
  }, [context, query]);

  const handleTips = (tip: IFullTipSchema) => {
    setClickedTip({ ...tip });
  };

  const handleSearchButtonClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      setModalOpen();
    },
    [setModalOpen],
  );

  return (
    <>
      <Responsive desktop>
        <DesktopSearchBlockLayout>
          <DesktopSearchInputContainer clickedTip={clickedTip} />
          <Experiment name={BX_DESCKTOP_MAIN_PAGE} group="B">
            <SearchTipsContainer tips={tips} isMainPageTips={true} onClick={handleTips} />
          </Experiment>
        </DesktopSearchBlockLayout>
      </Responsive>
      <Responsive phone tablet>
        <MobileSearchBlock onSearchClick={handleSearchButtonClick} />
        <SearchBlockModalContainer open={isModalOpen} onClose={setModalClose} />
      </Responsive>
    </>
  );
};

SearchBlockContainer.displayName = 'SearchBlockContainer';
